import { Component } from '@angular/core';
import { SharedService } from 'app/shared/services/shared.service';
import { UserService } from 'app/shared/services/user.service';
import { DictionaryService } from 'app/shared/services/dictionary.service';
import { ModalsService } from 'app/shared/services/modals.service';

@Component({
  selector: 'messages-component',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss']
})

export class MessagesComponent {

  constructor(public sharedService: SharedService, public userService: UserService, public dictionaryService: DictionaryService, public modalsService: ModalsService) { }

  openGDPR() {
    this.modalsService.showModal({ 'title': this.dictionaryService.get('CEDATO_DPA'), 'component': "gdpr-agreement" });
  }

}
